/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DTOLeaveAppliedViewModal from './DTOLeaveAppliedViewModal';
import LeaveAppliedViewModalPresenter from './LeaveAppliedViewModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  leaveAppliedViewData?: any;
  trans?: any;
}

const LeaveAppliedViewModalController = ({
  isModalOpen,
  closeModal,
  leaveAppliedViewData,
  trans,
}: ModalInterface) => {
  return (
    <>
      <DTOLeaveAppliedViewModal />

      <LeaveAppliedViewModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        leaveAppliedViewData={leaveAppliedViewData}
        trans={trans}
      />
    </>
  );
};

export default LeaveAppliedViewModalController;
